import * as React from "react";
import { connect } from "react-redux";

import { SendOTP } from "./action";

import OTP from "../../screens/OTP";
class OTPContainer extends React.Component<Props, State> {
  render() {
    return <OTP SendOTP={this.props.SendOTP} />;
  }
}
function bindAction(dispatch) {
  return {
    SendOTP: () => {
      dispatch(SendOTP());
    },
  };
}
const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps, bindAction)(OTPContainer);
